var map = {
	"./M7-banner.png": "49c2",
	"./a-img-download1.png": "8241",
	"./a-img-download2.png": "0b01",
	"./ai-img-acode.png": "9749",
	"./ai-img-android.png": "50a9",
	"./ai-img-apple.png": "5494",
	"./ai-img-bg.png": "2d9d",
	"./ai-img-douyin-bg.png": "becc",
	"./ai-img-douyin.png": "8524",
	"./ai-img-download.png": "32ae",
	"./ai-img-ej.png": "64ff",
	"./ai-img-fyb.png": "e029",
	"./ai-img-fyj.png": "9138",
	"./ai-img-keyboard.png": "b87e",
	"./ai-img-language-w.png": "5ded",
	"./ai-img-language.png": "b3df",
	"./ai-img-mouse.png": "e650",
	"./ai-img-mouse1.png": "7a8d",
	"./ai-img-office.png": "a9b3",
	"./ai-img-p1.png": "a8b7",
	"./ai-img-p2.png": "9ca1",
	"./ai-img-p3.png": "9bd5",
	"./ai-img-pen.png": "1a6d",
	"./ai-img-qcode.png": "3f04",
	"./ai-img-qd.png": "0bcb",
	"./ai-img-ql.png": "b9d9",
	"./ai-img-qxm.png": "d624",
	"./ai-img-record.png": "8839",
	"./ai-img-recorder.png": "2897",
	"./ai-img-scan.png": "bba6",
	"./ai-img-service.png": "4bc7",
	"./ai-img-top.png": "776d",
	"./ai-img-topbg.png": "2f9b",
	"./ai-img-tx.png": "c9cb",
	"./ai-img-video.jpg": "a2ba",
	"./ai-img-w.png": "4c75",
	"./ai-img-yundesk.png": "cc97",
	"./aioffice_download/ai_key.png": "5a34",
	"./aioffice_download/m_key.png": "ed4e",
	"./aioffice_download/trans_key.png": "977e",
	"./aioffice_download/voice_key.png": "48b9",
	"./b_arrow.png": "2c35",
	"./beite-banner.png": "f8ff",
	"./bg.png": "3f6e",
	"./checked.png": "4f4e",
	"./dike-banner.png": "6cd0",
	"./hbs-banner.png": "833e",
	"./hgai-banner.png": "44dd",
	"./i70-banner.png": "78e3",
	"./info-circle-filled-b.png": "d764",
	"./info-circle-filled.png": "9568",
	"./jingying-banner.png": "6990",
	"./keliumao-banner.png": "b5ba",
	"./lefan-banner.jpg": "4e74",
	"./liantong-banner.png": "8fed",
	"./m70-banner.png": "4855",
	"./miaowang-banner.png": "18d6",
	"./mifi-banner.png": "e89b",
	"./newland-banner.png": "248a",
	"./p70-banner.png": "caf9",
	"./pansheng-banner.png": "d477",
	"./tele-banner.png": "2aba",
	"./vm1-mini.jpg": "1425",
	"./vm1-pro.jpg": "34c5",
	"./vm1-ultra.jpg": "54f8",
	"./windows.png": "9579",
	"./xunxiang-banner.png": "a4ce",
	"./yff-banner.jpg": "2201",
	"./yff-banner.png": "5a1e",
	"./yundesk-banner.png": "3f0e",
	"./zuoh-banner.png": "ad01",
	"./zxhy-banner.png": "a1b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";